exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html,\nbody,\n#tectonics {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n#tectonics {\n  display: flex;\n}\n\n#tectonics > section {\n  width: 100%;\n}\n", ""]);

